import { BaseFeature, FeatureType } from '@core/shared/feature';
export class DocumentationBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/documentation/feature","featureId":"common-documentation"},
      abilityActions: false,
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'DocumentationFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'DocumentationFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'DocumentationFrontendAdminFeature'
      },
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'DocumentationBackendFeature'},
      {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'DocumentationBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}